import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Pages/Home/Home'
import NeedsAnalysis from '@/components/Pages/Home/NeedsAnalysis'
import Profile from '@/components/User/Profile'
import Favorites from '@/components/User/Favorites'
import Property from '@/components/Property/Property'
import Properties from '@/components/SearchResults/Properties'
import Listing from '@/components/Listing/Listing'
import Login from '@/components/Pages/Login/Login'
import ForgotPassword from '@/components/Pages/ForgotPassword/ForgotPassword'
import ResetPasswordForm from '@/components/Pages/ForgotPassword/ResetPasswordForm'
import Register from '@/components/Pages/Register/Register'
import Default from '@/components/Pages/Default/Default'
import Contact from '@/components/Pages/Contact/Contact'
import PageNotFound from '@/components/Pages/PageNotFound/PageNotFound'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import store from '../store'
import _ from 'lodash'
import VueHead from 'vue-head'

Vue.use(VueHead)
Vue.use(PerfectScrollbar)
Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Home',
            meta: { layout: 'default' },
            component: Home
        },
        {
            path: '/properties',
            name: 'Properties',
            component: Properties,
            meta: { layout: 'search' },
            children: [
                {
                    path: ':id',
                    name: 'Property',
                    component: {
                        page: Property
                    },
                    meta: {
                        layout: 'search',
                        showModal: true
                    }
                }
            ]
        },
        {
            path: '/listing',
            name: 'Listing',
            component: Listing
        },
        {
            path: '/contact',
            name: 'Contact Us',
            component: Contact
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            beforeEnter:(to, from, next) => {
                if (store.getters['user/isLoggedIn']) {
                    next('/profile')
                    return
                }
                next()
            }
        },
        {
            path: '/forgotten-password',
            name: 'Forgotten Password',
            component: ForgotPassword
        },
        {
            path: '/register',
            name: 'Register',
            component: Register
        },
        {
            path: '/profile',
            name: 'profile',
            component: Profile,
            beforeEnter: (to, from, next) => {
                if (store.getters['user/isLoggedIn']) {
                    next()
                    return
                }
                next('/login')
            }
        },
        {
            path: '/favorites',
            name: 'favorites',
            component: Favorites,
            beforeEnter: (to, from, next) => {
                if (store.getters['user/isLoggedIn']) {
                    next()
                    return
                }
                next('/login')
            }
        },
        {
            path: '/reset-password/:token',
            name: 'reset-password-form',
            component: ResetPasswordForm,
            meta: {
                auth: false
            }
        },
        {
            path:'/needs-assessment',
            name:'needs-assessment',
            component:NeedsAnalysis,
        }
    ]
})

store.dispatch('general/getPages', {})
    .then(pages => {
    _.forEach(pages,function(page) {
        router.addRoutes([
            {
                path: page.slug,
                component: Default,
            },
        ]);
    })
    router.addRoutes([
        {
        path: '*',
            name: 'page-not-found',
            component: PageNotFound
        },
    ]);
})

router.beforeEach((to, from, next) => {
    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters['user/isLoggedIn']) {
            next()
            return
        }
        next('/login')
    } else {
        next()
    }
    next();
})

export default router